<template>

    <v-modal :title="title">
        <template #body>
            <v-alert :message="error" />
            <v-alert v-if="broadcast.smart_sending" type="info">You have Smart Sending enabled, which means customers can only be emailed once every {{ project.send_interval }} {{ 'day' | pluralize(project.send_interval) }}.</v-alert>
            <p v-if="broadcast.is_active && !broadcast.processed_at">Are you sure you want to unschedule:<br>{{ broadcast.name }}</p>
            <p v-else-if="!broadcast.is_active">Are you sure you want to schedule:<br>{{ broadcast.name }}</p>
            <p v-else>Updates can no longer be made to:<br>{{ broadcast.name }}</p>
        </template>
        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button v-if="broadcast.is_active && !broadcast.processed_at" size="sm" btn-style="danger" :loading="loading" @click.native="updateBroadcast">{{ title }}</v-button>
            <v-button v-else-if="!broadcast.is_active" size="sm" btn-style="success" :loading="loading" @click.native="updateBroadcast">{{ title }}</v-button>
            <div v-else></div>
        </template>
    </v-modal>

</template>

<script>

import CampaignApi from '@api/CampaignApi'

export default {

    data() {
        return {
            loading: false,
            error: null,
        }
    },

    computed: {

        broadcast() {
            return this.$store.getters['campaign/campaign'];
        },

        title() {
            if (this.broadcast.is_active && !this.broadcast.processed_at) {
                return 'Unschedule Broadcast';
            } else if (!this.broadcast.is_active) {
                return 'Schedule Broadcast';
            }
            return 'Schedule Broadcast';
        },

    },

    methods: {

        updateBroadcast() {
            if (this.broadcast.is_active && !this.broadcast.processed_at) {
                this.stopBroadcast();
            } else if (!this.broadcast.is_active) {
                this.startBroadcast();
            }
        },

        startBroadcast() {
            this.loading = true;
            CampaignApi.startCampaign(this.broadcast.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setCampaign', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.scheduled'));
                    this.$store.commit('showModal', false);
                    this.$router.push({ name: 'broadcasts' });
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        stopBroadcast() {
            this.loading = true;
            CampaignApi.stopCampaign(this.broadcast.id)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/setCampaign', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.unscheduled'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
